import { Box, Stack, Typography } from "@mui/material";
import React from "react";

const SearchedCard = ({ item }) => {
  const isStudent =
    !!item?.studentDocId || (!!item?.admissionNumber && !!item?.classInfo);

  // Student card
  if (isStudent) {
    return (
      <Stack
        direction={"row"}
        gap={2}
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#1373E511",
          border: "1px solid #1373E533",
          borderRadius: "8px",
          p: "12px",
          width: "fit-content",
          minWidth: 260,
        }}
      >
        <Box>
          <img
            src={item?.profilePic ?? "/image-placeholder.jpeg"}
            alt="student"
            style={{ width: "60px", height: "60px", borderRadius: "10%" }}
          />
        </Box>
        <Box>
          <Typography sx={{ fontWeight: 600, fontSize: "15px" }}>
            {item?.name ?? "-"}
          </Typography>
          <Stack direction="row" gap={2} mt={0.5}>
            <Box>
              <Typography sx={{ fontWeight: 500, fontSize: "12px" }}>
                Class: {item?.classInfo ?? "--"}
              </Typography>

              <Typography sx={{ fontWeight: 500, fontSize: "12px" }}>
                Father Name: {item?.fatherName ?? "--"}
              </Typography>
            </Box>
          </Stack>
        </Box>
      </Stack>
    );
  }

  // Staff card
  return (
    <Stack
      direction={"row"}
      gap={2}
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#1373E511",
        border: "1px solid #1373E533",
        borderRadius: "8px",
        p: "12px",
        width: "fit-content",
        minWidth: 260,
      }}
    >
      <Box>
        <img
          src={item?.profilePic ?? "/image-placeholder.jpeg"}
          alt="profile"
          style={{ width: "60px", height: "60px", borderRadius: "10%" }}
        />
      </Box>
      <Box>
        <Typography sx={{ fontWeight: 600, fontSize: "15px" }}>
          {item?.fullName ?? item?.name ?? "-"}
          {item?.employeeId && (
            <span style={{ color: "#2789FD" }}> ({item?.employeeId})</span>
          )}
        </Typography>
        <Stack direction="row" gap={2} mt={0.5}>
          <Box>
            <Typography sx={{ fontWeight: 500, fontSize: "12px" }}>
              Designation: {item?.designation ?? "--"}
            </Typography>

            <Typography sx={{ fontWeight: 500, fontSize: "12px" }}>
              Department: {item?.departmentName ?? "--"}
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
};

export default SearchedCard;
